import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IdentityVerificationRequest, IdentityVerificationResponse } from '../../interfaces/requests/identity-verification.interface';

const env = environment;

@Injectable({
  providedIn: 'root'
})
export class IdentityVerificationService {
  private http = inject(HttpClient);

  validateIdentity(data: IdentityVerificationRequest): Observable<IdentityVerificationResponse> {
    let token: string | null = null;
    if (typeof window !== 'undefined') {
      token = localStorage.getItem('tokenn');
    }
    const url = `${env.apiUrl}/identity-verifications/validate`;

    return this.http.post<IdentityVerificationResponse>(url, data, {
      headers: {
        Authorization: `Bearer ${token ?? ''}`,
        'Content-Type': 'application/json',
      }
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  resendVerification(userId: string): Observable<any> {
    let token: string | null = null;
    if (typeof window !== 'undefined') {
      token = localStorage.getItem('tokenn');
    }
    const url = `${env.apiUrl}/identity-verifications/resend`;

    return this.http.post<any>(url, {
      userId,
      identityType: 'GHANA_CARD'
    }, {
      headers: {
        Authorization: `Bearer ${token ?? ''}`,
        'Content-Type': 'application/json',
      }
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  resetPin(userId: string): Observable<any> {
    let token: string | null = null;
    if (typeof window !== 'undefined') {
      token = localStorage.getItem('tokenn');
    }
    const url = `${env.apiUrl}/users/${userId}/reset-pin`;

    return this.http.patch<any>(url, null, {
      headers: {
        Authorization: `Bearer ${token ?? ''}`,
      }
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }

  verifyIdentity(formData: FormData): Observable<any> {
    let token: string | null = null;
    if (typeof window !== 'undefined') {
      token = localStorage.getItem('tokenn');
    }
    const url = `${env.apiUrl}/identity-verifications/verify`;

    return this.http.post<any>(url, formData, {
      headers: {
        Authorization: `Bearer ${token ?? ''}`,
      }
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }
}
